export const ONE_DAY_IN_SECONDS = 24 * 60 * 60
export const ONE_WEEK_IN_SECONDS = 7 * ONE_DAY_IN_SECONDS

export const COVER_HEIGHT_RATIO = 1.4

export const BookSize = { 
    lg: { 
        height: 410,
        width: 410 / COVER_HEIGHT_RATIO,
    },
    md: {
        height: 330,
        width: 330 / COVER_HEIGHT_RATIO,
    },
    sm: {
        height: 140,
        width: 140 / COVER_HEIGHT_RATIO,
    },
    xs: {
        height: 120,
        width: 120 / COVER_HEIGHT_RATIO,
    },
    xxs: {
        height: 100,
        width: 100 / COVER_HEIGHT_RATIO,
    }
}
export const BOOK_HEIGHT_LG = 410
export const BOOK_WIDTH_LG = BOOK_HEIGHT_LG / COVER_HEIGHT_RATIO

export const BOOK_HEIGHT_MD = 220
export const BOOK_WIDTH_MD = BOOK_HEIGHT_MD / COVER_HEIGHT_RATIO

export const BOOK_HEIGHT_SM = 140
export const BOOK_WIDTH_SM = BOOK_HEIGHT_SM / COVER_HEIGHT_RATIO

export const BOOK_HEIGHT_XS = 120
export const BOOK_WIDTH_XS = BOOK_HEIGHT_XS / COVER_HEIGHT_RATIO
